import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class FeatureTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "numberColumn", title: "#" },
        { name: "componentColumn", title: "Component" },
        { name: "functionColumn", title: "Function" },
      ],
      rows: [
        { numberColumn: '01', componentColumn: 'Photosensor', functionColumn: 'Twilight switch for IR-LEDs' },
        { numberColumn: '02', componentColumn: 'Infrared-LEDs', functionColumn: '6 IR LEDs (invisible @940nm) and 4 IR LEDs (slightly red visible @850nm)' },
        { numberColumn: '03', componentColumn: 'Lense', functionColumn: 'Wide-angle (focal length: 4.3mm / field of view: ~ 90º dia.)' },
        { numberColumn: '04', componentColumn: 'Microphone', functionColumn: 'For noise detection / audio rec. / two-way audio intercom' },
        { numberColumn: '05', componentColumn: 'PIR-Sensor', functionColumn: 'Integrated passive infrared (PIR) motion detector' },
        { numberColumn: '06', componentColumn: 'Status LED', functionColumn: 'Red: Power; Blue: Network Status; Both can be disabled. (see LED modes, below)' },
        { numberColumn: '07', componentColumn: 'Speaker', functionColumn: 'Integrated loudspeaker' },
        { numberColumn: '08', componentColumn: 'Antenna', functionColumn: 'Built-in 3dB Antenna' },
        { numberColumn: '09', componentColumn: 'Camera Label', functionColumn: 'P2P ID, LAN MAC address and serial number' },
        { numberColumn: '10', componentColumn: 'WPS / Reset', functionColumn: 'Three seconds for WPS WiFi setup / 20 seconds for reset' },
        { numberColumn: '11', componentColumn: 'SD Card Reader', functionColumn: 'Slot for MicroSD/SDXC cards (max. 256GB - 32GB included) - inside the camera' },
        { numberColumn: '12', componentColumn: 'Mounting Thread / Bracket', functionColumn: 'The bracket can be used as wall mount or ceiling mount when connected to either one of the two mounting threads' },
        { numberColumn: '13', componentColumn: 'Power Connector', functionColumn: 'For included 5V / 2A power supply' },
        { numberColumn: '14', componentColumn: 'Network Port', functionColumn: 'RJ45 LAN port / connector for Cat5e LAN cable or better' },
        { numberColumn: '15', componentColumn: 'Screw Lock', functionColumn: 'For desk-top, wall and ceiling installation' },
        { numberColumn: '16', componentColumn: 'Built-in Magnet', functionColumn: 'For wall mount use together with metal mounting plate' }
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

FeatureTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(FeatureTable)